<template>
  <div id="app" :class="appClasses">
    <header v-if="isMobile">
      <MobileNav />
    </header>

    <div class="block-wrapper" v-if="!isMobile">
      <Intro />
    </div>

    <div class="block-wrapper timeline-block-wrapper" v-if="!isMobile">
      <div class="content-wrapper timeline-content-wrapper">
        <Timeline />
      </div>
    </div>

    <DecadeNav v-if="!isMobile" />

    <div v-if="isMobile" class="mobile-wrapper">
      <Intro v-if="selectedDecade === 0" />
      <TimelineMobile />
    </div>

    <DecadeNavMobile v-if="isMobile" />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import Intro from './Intro.vue';
  import DecadeNav from './DecadeNav.vue';
  import DecadeNavMobile from './DecadeNavMobile.vue';
  import Timeline from './Timeline.vue';
  import TimelineMobile from './TimelineMobile.vue';
  import MobileNav from './MobileNav.vue';

  export default {
    mounted() {
      this.setLoaded(true);
      this.handleResize();
      this.handleHashChange();
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('hashchange', this.handleHashChange);
    },
    computed: {
      ...mapGetters([
        'isMobile',
        'selectedDecade',
        'timelineTransitioning',
        'loaded',
        'decadeIndices',
        'decadeBarsInitialHeight',
      ]),
      appClasses() {
        return {
          'loaded': this.loaded,
          'show-timeline': this.selectedDecade !== 0,
          'timeline-transitioning-in': this.timelineTransitioning === 'in',
          'timeline-transitioning-out': this.timelineTransitioning === 'out'
        };
      }
    },
    methods: {
      ...mapActions([
        'selectDecade',
        'setLoaded',
        'setIsMobile',
        'setContainerHeight',
        'setWindowHeight',
        'setWindowWidth',
        'setIntroScrollTop',
        'setContainerScrollTop',
      ]),
      handleResize() {
        this.detectMobile();
        this.setWindowHeight(window.innerHeight);
        this.setWindowWidth(window.innerWidth);
      },
      handleHashChange() {
        const decade = window.location.hash.replace('#', '').replace('s', '');
        this.selectDecade(decade);
      },
      detectMobile() {
        const isMobile = window.innerWidth < 1024 || window.innerHeight < 760;
        if (isMobile !== this.isMobile) {
          document.body.scrollTop = 0;
          this.setIntroScrollTop(0);
          this.setContainerScrollTop(0);
        }
        this.setIsMobile(isMobile);
      }
    },
    components: {
      Intro,
      DecadeNav,
      DecadeNavMobile,
      Timeline,
      TimelineMobile,
      MobileNav
    }
  }
</script>


// WEBPACK FOOTER //
// App.vue?1d637f9e